import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
    //   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    baseURL: process.env.VUE_APP_BASE_URL,
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.state.auth.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            // config.headers['X-Token'] = store.state.auth.token
            config.headers.Authorization = 'Bearer ' + store.state.auth.token
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // console.log(response)
        if (response.headers.refreshToken) {
            store.dispatch('auth/setToken', response.headers.refreshToken)
        }
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 0) {
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 500 && (res.msg === "未携带token" || res.msg === "token已过期" || res.msg === "非法用户" || res.msg === "token异常")) {
                // to re-login
                MessageBox.confirm('登录状态异常，请重新登录', '状态异常', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('auth/setToken').then(() => {
                        location.reload()
                    })
                })
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log(error.response)
        if (error.response && error.response.data && error.response.data.status === 500) {
            let message = error.response.data.message
            if (message === "未携带token" || message === "token已过期" || message === "非法用户" || message === "token异常") {
                // to re-login
                MessageBox.confirm('登录状态异常，请重新登录', '状态异常', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('auth/setToken').then(() => {
                        location.reload()
                    })
                })
            } else {
                Message({
                    message: error.message,
                    type: 'error',
                    duration: 5 * 1000
                })
            }
        } else {
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
